module.exports = __webpack_public_path__ + "static/newslogos-e9d1055758be2b19b06eeb5c852b8bf4.svg";